export default __webpack_public_path__ + "static/media/vampire.0d9b39e0.svg";